import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Card, Loader } from 'semantic-ui-react';

export const CardData = ({ title, color, total, loading }) => {
  const fontSize = _.isString(total) && total.length > 15 ? 25 : 35;
  return (
    <Card>
      <Card.Content textAlign="center">
        <Card.Header>{title}</Card.Header>
        <Card.Description style={{ color, fontSize, fontWeight: 'bolder', marginTop: '20px', whiteSpace: 'nowrap' }}>
          {loading ? <Loader active inline size="small" /> : total}
        </Card.Description>
      </Card.Content>
    </Card>
  );
};

CardData.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  loading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/components/DashboardCommissioning/CardData/index.js